// components
import FormValidation from '@/js/components/forms/form_validation';
import GoogleMaps from '@/js/components/google_maps/map';

class EventsDetail {
  constructor() {
    this.dom = {
      mapEl: document.getElementById('event-map'),
      formSign: document.getElementById('form-event-signup'),
      ticketFieldset: document.getElementById('event-price-type-select'),
      invalidFeedback: document.querySelector('#event-price-type-wrapper .invalid-feedback'),
    };

    this.props = {
      mapMarker: null,
      mapOptions: null,
      infoWindowContent: null,
      maxTickets: 0,
    };

    this.components = {
      googleMaps: null,
      signFormValidation: null,
    };

    this.events = {
      onMapLoaded: this.onMapLoaded.bind(this),
      onTicketChange: this.onTicketChange.bind(this),
      onFormError: this.onFormError.bind(this),
      onFormSuccess: this.onFormSuccess.bind(this),
    };

    this.mount();
  }

  mount() {
    if (this.dom.mapEl) {
      this.initMaps();
    }

    if (this.dom.formSign) {
      this.components.signFormValidation = new FormValidation(this.dom.formSign);

      // Listen for dispatched events from FormValidation
      this.dom.formSign.addEventListener('error', this.events.onFormError);
      this.dom.formSign.addEventListener('success', this.events.onFormSuccess);
    }

    if (this.dom.ticketFieldset) {
      this.initTicketLimit();
    }
  }

  initMaps() {
    this.props.mapOptions = {
      center: { lat: 50.91263082619794, lng: 3.647702889873862 },
    };
    // parse props
    const latitude = parseFloat(this.dom.mapEl.getAttribute('data-latitude'));
    const longitude = parseFloat(this.dom.mapEl.getAttribute('data-longitude'));

    this.props.mapOptions.center = { lat: latitude, lng: longitude };

    // listen to map loaded
    this.dom.mapEl.addEventListener('loaded', this.events.onMapLoaded);

    // create map instance
    this.components.googleMaps = new GoogleMaps(this.dom.mapEl, this.props.mapOptions);
  }

  onMapLoaded() {
    // Add a marker at the map's center coordinates
    const centerMarker = {
      position: this.props.mapOptions.center, // Use the center coordinates from mapOptions
    };

    this.components.googleMaps.addMarker(centerMarker);
  }

  /**
   * Ticket selection limit logic
   */
  initTicketLimit() {
    const fieldset = this.dom.ticketFieldset;

    const maxAmount = parseInt(fieldset.dataset.amount || '0', 10);
    this.props.maxTickets = maxAmount;
    this.dom.ticketInputs = fieldset.querySelectorAll('.custom-number-input input');

    // CASE 1: max = 0 → disable everything
    if (maxAmount === 0) {
      this.dom.ticketInputs.forEach((input) => {
        // eslint-disable-next-line no-param-reassign
        input.value = 0;
        // eslint-disable-next-line no-param-reassign
        input.disabled = true;
        input.closest('.custom-number-input').classList.add('is-disabled');
      });
      return;
    }

    // CASE 2: normal limit > 0
    this.dom.ticketInputs.forEach((input) => {
      // eslint-disable-next-line no-param-reassign
      input.disabled = false;
      input.addEventListener('input', this.events.onTicketChange);
      input.addEventListener('change', this.events.onTicketChange);
    });

    // initialize limits
    this.updateTicketLimits();
  }

  getTotalTickets() {
    return Array.from(this.dom.ticketInputs || []).reduce(
      (sum, el) => sum + parseInt(el.value || 0, 10),
      0,
    );
  }

  updateTicketLimits() {
    const total = this.getTotalTickets();
    const remaining = Math.max(0, this.props.maxTickets - total);

    this.dom.ticketInputs.forEach((input) => {
      const currentValue = parseInt(input.value || 0, 10);
      // eslint-disable-next-line no-param-reassign
      input.max = currentValue + remaining;
    });
  }

  onTicketChange(e) {
    const input = e.target;
    const total = this.getTotalTickets();

    if (total > this.props.maxTickets) {
      const excess = total - this.props.maxTickets;
      input.value = Math.max(0, parseInt(input.value || 0, 10) - excess);
    }

    this.updateTicketLimits();
  }

  /**
   * Handle form validation error
   */
  onFormError(event) {
    const detail = event.detail || {};
    const errors = detail.errors || {};

    if (errors.Amount && this.dom.invalidFeedback) {
      this.dom.invalidFeedback.textContent = errors.Amount;
      this.dom.invalidFeedback.style.display = 'block';
      this.dom.invalidFeedback.classList.add('d-block');
    } else if (this.dom.invalidFeedback) {
      // Hide if no Amount error
      this.dom.invalidFeedback.textContent = '';
      this.dom.invalidFeedback.style.display = 'none';
      this.dom.invalidFeedback.classList.remove('d-block');
    }

    // mark all ticket inputs invalid
    if (this.dom.ticketFieldset) {
      const inputs = this.dom.ticketFieldset.querySelectorAll('input');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < inputs.length; i++) {
        if (errors.Amount) {
          inputs[i].classList.add('is-invalid');
        } else {
          inputs[i].classList.remove('is-invalid');
        }
      }
    }
  }

  /**
   * Handle form validation success
   */
  onFormSuccess() {
    if (this.dom.invalidFeedback) {
      this.dom.invalidFeedback.textContent = '';
      this.dom.invalidFeedback.style.display = 'none';
      this.dom.invalidFeedback.classList.remove('d-block');
    }

    // remove invalid styling
    if (this.dom.ticketFieldset) {
      const inputs = this.dom.ticketFieldset.querySelectorAll('input');
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].classList.remove('is-invalid');
      }
    }
  }
}

if (document.getElementById('page-events-detail')) {
  // eslint-disable-next-line no-new
  new EventsDetail();
}
